import { Component } from '@angular/core';

@Component({
    selector: 'app-root-default',
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.scss']
})
export class Unauthorized   {

    constructor() { }
}
